import React, { useState, useEffect } from "react";
import Socials from "./Socials";
import List from "./List";
import styled from "styled-components";
import lightLogo from "../assets/light-logo.svg";
import close from "../assets/close.svg";
import menu from "../assets/menu.svg";
import { motion } from "framer-motion";
const Navbar = () => {
  const [openSide, setOpenSide] = useState(false);
  const navAnimation = {
    hidden: {
      y: "-100%",
    },
    visible: {
      y: "0",
      transition: { duration: 1 },
    },
  };
  useEffect(() => {
    openSide
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [openSide]);
  return (
    <NavBar variants={navAnimation} initial="hidden" animate="visible">
      <div className="logo-description">
        <img src={lightLogo} alt="Veezy.com" />
      </div>
      <div className="main-nav">
        <List />
        <Socials />
      </div>
      <button
        className="open-nav"
        onClick={() => setOpenSide((prevState) => !prevState)}
      >
        <img src={menu} alt="" />
      </button>
      <div
        className={`side-nav ${openSide ? "open-side-nav" : "close-side-nav"}`}
      >
        <button
          onClick={() => setOpenSide((prevState) => !prevState)}
          className="close-side-btn"
        >
          <img src={close} />
        </button>
        <List />
        <Socials />
      </div>
    </NavBar>
  );
};

export default Navbar;

const NavBar = styled(motion.nav)`
  height: 5rem;
  width: 100%;
  padding: 0 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  position: fixed;
  z-index: 9999;
  background: #fefefe;
  .logo-description {
    display: flex;
    align-items: center;
    flex-basis: 20%;
    img {
      height: 4rem;
      width: 4rem;
      border: 1px solid black;
      border-radius: 50%;
      margin: 0;
      padding: 0;
    }
  }
  .main-nav {
    display: flex;
    flex-basis: 90%;
  }
  .side-nav {
    display: none;
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    width: 50%;
    background: #fefefe;
    border-left: 1px solid black;
    transition: transform 0.5s ease;
    .close-side-btn {
      border: none;
      background: none;
      height: 2rem;
      width: 2rem;
      margin: 1rem 0;
      cursor: pointer;
    }
  }
  .open-side-nav {
    transform: translateX(0%);
  }
  .close-side-nav {
    transform: translateX(100%);
  }

  .open-nav {
    background: none;
    border: none;
    height: 2rem;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    cursor: pointer;
    display: none;
    img {
      width: 100%;
      height: 100%;
    }
  }

  @media only screen and (max-width: 1145px) {
    .list {
      flex-basis: 40%;
    }
  }
  @media only screen and (max-width: 930px) {
    padding: 0 1rem;
  }
  @media only screen and (max-width: 685px) {
    .main-nav {
      display: none;
    }
    .side-nav {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .open-nav {
      display: block;
    }
  }
`;
